/**
 * Created with Mei Zhiwei on 2017-11-30 17:03:32.
 * Description: 初始化 VUEX
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-08-28 19:31:31
 */
import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import base from './modules/base';
import constants from './modules/constants';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    base,
    constants
  },
  strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js